<template>
    <p v-if="descriptionExtras || productExtraDisplayLabels" class="font-semibold italic text-gray-700">
        {{ descriptionExtras || productExtraDisplayLabels }}
    </p>
</template>

<script setup lang="ts">
    import type { ProductProps } from '~/types/local-types'
    const props = defineProps<ProductProps>()
    const { t } = useI18n()
    // TODO: make this a helper function with optional prefix so it can be reused in the cartProductCard component
    const productExtraDisplayLabels = computed(() => {
        let arr: string[] = []
        let extraDisplayLabels: string = ''
        if (props.extras && props.extras.length > 0) {
            extraDisplayLabels = `${t('shopPage.product.choiceFrom')}: `
            Object.values(props.extras).forEach(extra => {
                if (extra?.isVisible) {
                    Object.values(extra.items).forEach(extraItem => {
                        if (extraItem?.title && extraItem.title !== '') {
                            arr.push(extraItem.title)
                        }
                    })
                }
            })
        }
        if (arr.length > 6) {
            arr = arr.slice(0, 6)
            extraDisplayLabels = `${extraDisplayLabels + arr.join(', ')} ${t('shopPage.product.andMore')}.`
        } else {
            extraDisplayLabels = extraDisplayLabels + arr.join(', ')
        }
        return extraDisplayLabels
    })
</script>
